// extracted by mini-css-extract-plugin
module.exports = {"features":"FeaturesList_features__83D_2","separator":"FeaturesList_separator__2n11N","container":"FeaturesList_container__hFRTj","label":"FeaturesList_label__kgFi1"};